(function () {
    const DEFAULT_FILES_CDN = 'https://cdn.shopify.com/s/files/1/0790/9218/7414/files/';
    const filterContainers = document.querySelectorAll('.filter-container-json');

    // Catalog-wide collections that must show an empty vehicle filter (no brand/model preselected).
    const EMPTY_FILTER_HANDLES = ['all', 'all-car-mats'];
    const brandsJsonPromises = window.__evamatsAllBrandsJsonPromises || (window.__evamatsAllBrandsJsonPromises = {});
    // Texts come from the locale files through window.EVAMATS_I18N (layout/theme.liquid)
    const evmI18n = window.EVAMATS_I18N || {};
    const searchCopy = { searching: evmI18n.searching || '', empty: evmI18n.noResults || '' };

    if (!filterContainers.length) {
        return;
    }

    function loadBrandsJson(url) {
        if (!url) {
            return Promise.reject(new Error('Missing all_brands.json URL'));
        }
        if (!brandsJsonPromises[url]) {
            brandsJsonPromises[url] = fetch(url)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(`HTTP ${response.status} while loading ${url}`);
                    }
                    return response.text();
                })
                .then((rawText) => {
                    try {
                        return JSON.parse(rawText);
                    } catch (parseError) {
                        const match = String(parseError && parseError.message || '').match(/position\s+(\d+)/i);
                        const position = match ? parseInt(match[1], 10) : -1;
                        if (position >= 0) {
                            const start = Math.max(0, position - 120);
                            const end = Math.min(rawText.length, position + 120);
                            console.error('Error parsing JSON at position:', position);
                            console.error('JSON fragment before error:', rawText.slice(start, position));
                            console.error('JSON fragment after error:', rawText.slice(position, end));
                        }
                        throw parseError;
                    }
                });
        }
        return brandsJsonPromises[url];
    }

    function needsEagerBrandsLoad(container) {
        return (
            container.dataset.filterUi === 'hero' ||
            container.dataset.filterUi === 'collection' ||
            container.dataset.autoNavigate === 'true' ||
            Boolean((container.dataset.collectionHandle || '').trim())
        );
    }

    function scheduleBrandsLoad(startLoad) {
        let started = false;
        const run = () => {
            if (started) return;
            started = true;
            startLoad();
        };

        const hasEager = Array.from(filterContainers).some(needsEagerBrandsLoad);
        if (hasEager) {
            run();
            return run;
        }

        if (typeof requestIdleCallback === 'function') {
            requestIdleCallback(run, { timeout: 2000 });
        } else {
            window.addEventListener('load', run, { once: true });
            setTimeout(run, 2000);
        }

        document.addEventListener(
            'click',
            (event) => {
                if (
                    event.target.closest('.header__car') ||
                    event.target.closest('.filter-container-json')
                ) {
                    run();
                }
            },
            true
        );
        document.addEventListener(
            'focusin',
            (event) => {
                if (event.target.closest('.filter-container-json .brand-input')) {
                    run();
                }
            },
            true
        );

        return run;
    }

    function shouldStartEmpty(container) {
        const handle = (container.dataset.collectionHandle || '').trim().toLowerCase();
        return EMPTY_FILTER_HANDLES.includes(handle);
    }

    function getFilesCdn(container) {
        const base = container.dataset.filesCdn || DEFAULT_FILES_CDN;
        return base.endsWith('/') ? base : `${base}/`;
    }

    function fileUrl(container, filename) {
        const name = String(filename || '').trim();
        if (!name) return '';
        return getFilesCdn(container) + name;
    }

    function isHeroFilter(container) {
        return container.dataset.filterUi === 'hero';
    }

    function allowsFilterThumbs(container) {
        const ui = container.dataset.filterUi;
        return ui === 'hero' || ui === 'collection';
    }

    function findGeneration(years, generations) {
        if (!Array.isArray(generations) || !years) return null;
        const value = String(years).trim();
        return generations.find((item) => item && String(item.years).trim() === value) || null;
    }

    function formatGenerationLabel(generation, years) {
        const yearLabel = String(years || '').trim();
        if (!generation || !generation.code) return yearLabel;
        return `${String(generation.code).trim()} · ${yearLabel}`;
    }

    function parseYearRangeForVehicleFilter(text) {
        const normalized = String(text || '').trim().replace(/\u2013|\u2014|\u2212/g, '-');
        const range = normalized.match(/(\d{4})\s*-\s*(\d{4})/);
        if (range) {
            let a = parseInt(range[1], 10);
            let b = parseInt(range[2], 10);
            if (isNaN(a) || isNaN(b)) return null;
            if (a > b) {
                const tmp = a;
                a = b;
                b = tmp;
            }
            return { start: a, end: b };
        }
        const single = normalized.match(/^(\d{4})$/);
        if (single) {
            const y = parseInt(single[1], 10);
            return isNaN(y) ? null : { start: y, end: y };
        }
        return null;
    }

    function slugifyBrand(name) {
        return String(name || '')
            .trim()
            .toLowerCase()
            .replace(/\s+/g, '-');
    }

    // EVAMATS_CATALOG_LOCALE_ROUTES_20260907: all selector exits keep the active Shopify locale.
    function localizeCatalogUrl(value) {
        const raw = String(value || '').trim();
        if (!raw) return '';
        let url;
        try { url = new URL(raw, window.location.origin); } catch (_) { return ''; }
        if (url.origin !== window.location.origin) return '';
        const match = url.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(collections\/[a-z0-9-]+)\/?$/i);
        if (!match) return '';
        const root = String((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/');
        if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(root)) return '';
        return root + match[1] + url.search + url.hash;
    }

    function extractCollectionHandle(url) {
        return String(url || '')
            .trim()
            .replace(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\//i, '')
            .split('?')[0]
            .toLowerCase();
    }

    function resolveBrandCollectionUrl(brandKey, brandData) {
        if (brandData && brandData.url) {
            return String(brandData.url).trim();
        }
        return `/collections/${slugifyBrand(brandKey)}`;
    }

    function getYearsFilterFromUrl() {
        return new URLSearchParams(window.location.search).get('filter.p.m.custom.filter_years') || '';
    }

    function buildFilterUrl(modelUrl, years) {
        const path = localizeCatalogUrl(modelUrl);
        if (!path) return '';
        const url = new URL(path, window.location.origin);
        const yearsValue = String(years || '').trim();
        if (yearsValue) {
            url.searchParams.set('filter.p.m.custom.filter_years', yearsValue);
        }
        return url.pathname + url.search;
    }

    function isSameFilterLocation(targetUrl) {
        const target = new URL(String(targetUrl || '').trim(), window.location.origin);
        const current = window.location;
        return target.pathname === current.pathname && target.search === current.search;
    }

    /* --- 2026-09-21 (владелец): выбор больше не перезагружает страницу целиком -------------------------
       Раньше любой выбор в панели делал window.location.href: страница белела и собиралась заново вместе с
       шапкой, баннером и самой панелью. Теперь новая страница читается фоном, а меняется только то, что ниже
       панели: старое гаснет, под панелью бежит тонкая полоска, новое въезжает. Панель переезжает в новое
       дерево тем же узлом — ничего не перемонтируется и не мигает. Любая осечка (нет истории, на целевой
       странице нет панели, сеть) — обычный переход, как раньше. */
    const SWAP_KEEP_CLASS = 'evm-swap-keep';
    const SWAP_MIN_MS = 220;   // меньше — полоска успевает только моргнуть
    let swapBusy = false;

    const swapMain = () => document.getElementById('MainContent');
    const swapAside = () => document.querySelector('.evamats-collection-product-grid__filter');

    function swapReducedMotion() {
        return Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    }

    function canSoftSwap() {
        return Boolean(
            !swapBusy &&
            window.history &&
            typeof window.history.pushState === 'function' &&
            typeof window.DOMParser === 'function' &&
            swapMain() &&
            swapAside()
        );
    }

    // Ссылки на таблицы стилей лежат внутри подменяемого куска. Один раз поднимаем их в <head>, иначе при
    // подмене они исчезнут вместе со старой разметкой и панель на кадр останется без оформления.
    function hoistSwapStyles() {
        const main = swapMain();
        if (!main) return;
        const hrefs = new Set(
            Array.from(document.head.querySelectorAll('link[rel="stylesheet"]')).map((link) => link.getAttribute('href'))
        );
        Array.from(main.querySelectorAll('link[rel="stylesheet"]')).forEach((link) => {
            const href = link.getAttribute('href');
            link.remove();
            if (!href || hrefs.has(href)) return;
            hrefs.add(href);
            document.head.appendChild(link);
        });
    }

    // Из новой страницы забираем её стили: незнакомые ссылки и блоки <style> секций. Блоки помечаем, чтобы при
    // следующей подмене убрать стили секций, которых на странице уже нет.
    function takeSwapStyles(incoming) {
        const hrefs = new Set(
            Array.from(document.head.querySelectorAll('link[rel="stylesheet"]')).map((link) => link.getAttribute('href'))
        );
        const fresh = [];
        Array.from(incoming.querySelectorAll('link[rel="stylesheet"], style')).forEach((node) => {
            const href = node.getAttribute('href');
            node.remove();
            if (href) {
                if (hrefs.has(href)) return;
                hrefs.add(href);
            } else {
                node.setAttribute('data-evm-swap-style', '');
            }
            fresh.push(node);
        });
        return fresh;
    }

    function startSwapUi() {
        const main = swapMain();
        const aside = swapAside();
        if (!main || !aside) return;
        const section = aside.closest('.shopify-section');
        if (section) section.classList.add(SWAP_KEEP_CLASS);
        if (!aside.querySelector('.evm-swap-line')) {
            const line = document.createElement('span');
            line.className = 'evm-swap-line';
            line.setAttribute('aria-hidden', 'true');
            aside.appendChild(line);
        }
        main.classList.remove('evm-swap-enter');
        main.classList.add('evm-swap-busy');
    }

    function endSwapUi(entered) {
        const main = swapMain();
        if (!main) return;
        main.classList.remove('evm-swap-busy');
        if (!entered) return;
        main.classList.add('evm-swap-enter');
        window.setTimeout(() => main.classList.remove('evm-swap-enter'), 800);
    }

    // Тема переинициализирует свои секции по этому событию — тем же, которым пользуется редактор.
    function notifySwapSections(main) {
        main.querySelectorAll('.shopify-section').forEach((section) => {
            const sectionId = section.id.replace(/^shopify-section-/, '');
            section.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId } }));
        });
    }

    // Баннер и лента моделей над панелью у разных страниц разной высоты. Чтобы панель осталась ровно там, где
    // на неё нажали, сразу после подмены сдвигаем прокрутку на ту же величину — тогда с точки зрения человека
    // не двигается ничего, кроме содержимого ниже. У самого верха страницы сдвигать некуда, там панель просто
    // следует за своей страницей.
    function anchorPanel(aside, topBefore) {
        const delta = aside.getBoundingClientRect().top - topBefore;
        if (Math.abs(delta) < 1) return;
        const next = Math.max(0, window.scrollY + delta);
        if (next !== window.scrollY) window.scrollTo({ top: next, behavior: 'auto' });
    }

    // Прокрутку не трогаем, пока панель видна: человек сам решил, куда смотреть. Если он ушёл ниже — мягко
    // возвращаем её на экран, чтобы результат был виден сразу под поиском.
    function keepPanelInView(aside) {
        const rect = aside.getBoundingClientRect();
        if (rect.top >= 0) return;
        window.scrollTo({ top: window.scrollY + rect.top - 12, behavior: swapReducedMotion() ? 'auto' : 'smooth' });
    }

    async function softSwap(targetUrl, options) {
        const push = !options || options.push !== false;
        const main = swapMain();
        const aside = swapAside();
        if (!main || !aside) return false;
        let url;
        try { url = new URL(targetUrl, window.location.origin); } catch (_) { return false; }
        if (url.origin !== window.location.origin) return false;

        swapBusy = true;
        const startedAt = Date.now();
        startSwapUi();
        try {
            const response = await fetch(url.href, {
                credentials: 'same-origin',
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
            });
            if (!response.ok) throw new Error('ответ ' + response.status);
            const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
            const nextMain = doc.getElementById('MainContent');
            const nextAside = nextMain && nextMain.querySelector('.evamats-collection-product-grid__filter');
            if (!nextMain || !nextAside) throw new Error('на целевой странице нет панели поиска');

            const nextContainer = nextAside.querySelector('.filter-container-json');
            const nextData = nextContainer ? Object.assign({}, nextContainer.dataset) : null;
            const slot = doc.createElement('div');
            slot.setAttribute('data-evm-filter-slot', '');
            nextAside.replaceWith(slot);

            hoistSwapStyles();
            const incoming = document.adoptNode(nextMain);
            const freshStyles = takeSwapStyles(incoming);

            const wait = SWAP_MIN_MS - (Date.now() - startedAt);
            if (wait > 0) await new Promise((resolve) => setTimeout(resolve, wait));

            // Высоту панели над сгибом меряем, пока она ещё в живом документе: как только узел уезжает в
            // новое дерево, он отцеплен и его прямоугольник — нули.
            const panelTop = aside.getBoundingClientRect().top;
            const liveSlot = incoming.querySelector('[data-evm-filter-slot]');
            if (liveSlot) liveSlot.replaceWith(aside);
            else incoming.prepend(aside);

            document.head.querySelectorAll('style[data-evm-swap-style]').forEach((node) => node.remove());
            freshStyles.forEach((node) => document.head.appendChild(node));
            main.replaceChildren.apply(main, Array.from(incoming.childNodes));
            anchorPanel(aside, panelTop);

            if (push) window.history.pushState({ evmSwap: true }, '', url.pathname + url.search);
            if (doc.title) document.title = doc.title;
            const section = aside.closest('.shopify-section');
            if (section) section.classList.add(SWAP_KEEP_CLASS);

            notifySwapSections(main);
            endSwapUi(true);
            keepPanelInView(aside);

            const liveContainer = aside.querySelector('.filter-container-json');
            if (liveContainer && nextData && typeof liveContainer.__evamatsApplyPageContext === 'function') {
                await liveContainer.__evamatsApplyPageContext(nextData);
            }
            return true;
        } catch (error) {
            console.warn('[evamats] мягкий переход не удался, уходим обычным:', error);
            endSwapUi(false);
            window.location.href = url.href;
            return false;
        } finally {
            swapBusy = false;
        }
    }

    function navigateIfNeeded(targetUrl) {
        const url = localizeCatalogUrl(targetUrl);
        if (!url || isSameFilterLocation(url)) return;
        if (canSoftSwap()) {
            softSwap(url).catch(() => { window.location.href = url; });
            return;
        }
        window.location.href = url;
    }

    function normalizeCatalogLabel(value) {
        return String(value || '')
            .trim()
            .toLocaleLowerCase()
            .replace(/\s+/g, ' ');
    }

    function findCatalogMatch(catalog, handle, brandHint, modelHint) {
        const normalizedHandle = String(handle || '').trim().toLowerCase();
        const normalizedBrandHint = normalizeCatalogLabel(brandHint);
        const normalizedModelHint = normalizeCatalogLabel(modelHint);
        if (!catalog) return null;

        let brandMatch = null;
        let modelMatch = null;
        let hintedBrandMatch = null;
        let hintedModelMatch = null;

        Object.keys(catalog).forEach((brandKey) => {
            const brandData = catalog[brandKey];
            const cleanBrandKey = String(brandKey || '').trim();
            const brandHandle = extractCollectionHandle(resolveBrandCollectionUrl(cleanBrandKey, brandData));
            const brandCandidate = { brandKey, brandData, level: 'brand' };

            if (brandHandle === normalizedHandle) {
                brandMatch = brandCandidate;
            }
            if (
                normalizedBrandHint &&
                normalizeCatalogLabel(cleanBrandKey) === normalizedBrandHint
            ) {
                hintedBrandMatch = brandCandidate;
            }

            if (!brandData || !Array.isArray(brandData.models)) return;

            brandData.models.forEach((model) => {
                const modelHandle = extractCollectionHandle(model.url);
                const candidate = {
                    brandKey,
                    brandData,
                    model,
                    modelUrl: model.url,
                    level: 'model'
                };

                if (modelHandle === normalizedHandle) {
                    if (
                        !modelMatch ||
                        modelHandle.length > extractCollectionHandle(modelMatch.model.url).length
                    ) {
                        modelMatch = candidate;
                    }
                }

                if (
                    normalizedBrandHint &&
                    normalizedModelHint &&
                    normalizeCatalogLabel(cleanBrandKey) === normalizedBrandHint &&
                    normalizeCatalogLabel(model.name) === normalizedModelHint
                ) {
                    hintedModelMatch = candidate;
                }
            });
        });

        return modelMatch || brandMatch || hintedModelMatch || hintedBrandMatch;
    }

    function isAutoNavigate(container) {
        return container.dataset.autoNavigate === 'true';
    }

    filterContainers.forEach((container) => {
        const brandCustomSelect = container.querySelector('.brand-custom-select');
        const brandSelectOptions = container.querySelector('.brand-select-options');
        const modelCustomSelect = container.querySelector('.model-custom-select');
        const modelSelectOptions = container.querySelector('.model-select-options');
        const yearsCustomSelect = container.querySelector('.years-custom-select');
        const yearsSelectOptions = container.querySelector('.years-select-options');
        const clearFilters = container.querySelector('.clear-filters');
        const searchButton = container.querySelector('.search-button-json');
        const brandsModelsJsonUrl = container.dataset.json;
        const heroUi = isHeroFilter(container);

        let localJson;
        let selectedBrandLogo = '';
        let selectedModelGenerations = null;
        let suppressAutoNav = false;
        const autoNavEnabled = isAutoNavigate(container);

        function maybeNavigate(targetUrl) {
            if (!autoNavEnabled || suppressAutoNav) return;
            navigateIfNeeded(targetUrl);
        }

        let brandsLoadStarted = false;
        let brandsDataApplied = false;

        function setBrandOptionsLoading(isLoading) {
            if (!brandSelectOptions) return;
            const existing = brandSelectOptions.querySelector('.brand-select-loading');
            if (isLoading) {
                if (existing || brandSelectOptions.children.length) return;
                const loading = document.createElement('div');
                loading.className = 'brand-select-loading';
                loading.setAttribute('aria-busy', 'true');
                loading.textContent = searchCopy.searching;
                brandSelectOptions.appendChild(loading);
                return;
            }
            if (existing) existing.remove();
        }

        async function applyBrandsData(data) {
            if (brandsDataApplied) return;
            brandsDataApplied = true;
            setBrandOptionsLoading(false);
            localJson = data;
            populateBrandDropdown(localJson);
            if (shouldStartEmpty(container)) {
                localStorage.removeItem('carFilterSelections');
                return;
            }
            const restoredFromPage = await restoreSelectionsFromPageContext();
            if (!restoredFromPage) {
                await restoreSelectionsFromLocalStorage();
            }
        }

        function startBrandsLoad() {
            if (brandsLoadStarted) return;
            brandsLoadStarted = true;
            setBrandOptionsLoading(true);
            loadBrandsJson(brandsModelsJsonUrl)
                .then(applyBrandsData)
                .catch((error) => {
                    setBrandOptionsLoading(false);
                    console.error('Error loading JSON:', error);
                });
        }

        container.__evamatsStartBrandsLoad = startBrandsLoad;

        // 2026-09-21: после мягкого перехода панель остаётся тем же узлом — подставляем ей данные новой
        // страницы и пересобираем поля, как это делается при обычной загрузке.
        container.__evamatsApplyPageContext = async function (nextData) {
            ['collectionHandle', 'pageBrand', 'pageModel', 'autoNavigate', 'filterUi', 'filesCdn'].forEach((key) => {
                const value = nextData ? nextData[key] : '';
                if (value == null || value === '') delete container.dataset[key];
                else container.dataset[key] = value;
            });
            if (!localJson) return;
            suppressAutoNav = true;
            try {
                if (shouldStartEmpty(container)) {
                    clearFilters.click();
                } else if (!(await restoreSelectionsFromPageContext())) {
                    clearFilters.click();
                }
            } finally {
                suppressAutoNav = false;
            }
            updateClearButtons();
        };

        function sortLocale(a, b) {
            return String(a).trim().localeCompare(String(b).trim(), undefined, { sensitivity: 'base', numeric: true });
        }

        function setThumb(selectWrapper, filename, type) {
            if (!allowsFilterThumbs(container)) return;
            const thumb = selectWrapper.querySelector('.filter-field__thumb');
            if (!thumb) return;

            if (filename) {
                thumb.src = fileUrl(container, filename);
                thumb.hidden = false;
                selectWrapper.classList.add('filter-field--has-media');
                if (type === 'generation') {
                    selectWrapper.classList.add('filter-field--has-generation-media');
                }
                return;
            }

            thumb.hidden = true;
            thumb.removeAttribute('src');
            selectWrapper.classList.remove('filter-field--has-media', 'filter-field--has-generation-media');
        }

        function setFieldValue(selectWrapper, displayValue, filterValue) {
            const input = selectWrapper.querySelector('.select-selected');
            if (!input) return;
            input.value = displayValue;
            if (filterValue != null) {
                input.dataset.years = filterValue;
            } else {
                delete input.dataset.years;
            }
        }

        function resetYearsSelect() {
            const yearsInput = yearsCustomSelect.querySelector('.select-selected');
            yearsInput.value = '';
            delete yearsInput.dataset.years;
            yearsSelectOptions.innerHTML = '';
            yearsCustomSelect.classList.remove('selected');
            yearsInput.classList.add('disabled');
            yearsInput.setAttribute('disabled', 'disabled');
            setThumb(yearsCustomSelect, '', 'generation');
            selectedModelGenerations = null;
        }

        // Group keys in all_brands.json are English words ("Tractors", "Diggers"): show them localized, keep the key for lookups.
        function brandLabel(brand) {
            const key = String(brand).trim();
            const groups = evmI18n.brandGroups || {};
            return groups[key] || key;
        }

        function populateBrandDropdown(data) {
            brandSelectOptions.innerHTML = '';
            Object.keys(data)
                .sort((a, b) => sortLocale(brandLabel(a), brandLabel(b)))
                .forEach((brand) => {
                    const div = document.createElement('div');
                    div.textContent = brandLabel(brand);
                    div.dataset.brand = brand;
                    if (data[brand] && data[brand].logo) {
                        div.dataset.logo = String(data[brand].logo).trim();
                    }
                    div.addEventListener('click', function () {
                        const key = this.dataset.brand;
                        const brandUrl = key && data[key] ? resolveBrandCollectionUrl(key, data[key]) : '';

                        if (autoNavEnabled) {
                            saveSelectionsToLocalStorage({
                                brand: (this.textContent || '').trim(),
                                model: '',
                                modelUrl: '',
                                years: ''
                            });
                            // 2026-09-21: страница теперь не перезагружается, поэтому поле отвечает сразу —
                            // список закрывается, выбранное видно, а содержимое ниже догружается своим ходом.
                            selectOption(this, brandCustomSelect, brandSelectOptions, false);
                            brandCustomSelect.querySelector('.select-selected').dataset.url = brandUrl;
                            selectedBrandLogo = (this.dataset.logo || '').trim();
                            setThumb(brandCustomSelect, selectedBrandLogo, 'brand');
                            resetModelSelect();
                            resetYearsSelect();
                            setThumb(modelCustomSelect, '', 'generation');
                            maybeNavigate(brandUrl);
                            return;
                        }

                        selectOption(this, brandCustomSelect, brandSelectOptions, true);
                        brandCustomSelect.querySelector('.select-selected').dataset.url = brandUrl;
                        selectedBrandLogo = (this.dataset.logo || '').trim();
                        selectedModelGenerations = null;
                        resetModelSelect();
                        resetYearsSelect();
                        setThumb(brandCustomSelect, selectedBrandLogo, 'brand');
                        setThumb(modelCustomSelect, '', 'generation');
                        if (key && data[key] && Array.isArray(data[key].models)) {
                            populateModelDropdown(data[key].models);
                        }
                        enableModelSelect();
                        checkIfSearchEnabled();
                    });
                    brandSelectOptions.appendChild(div);
                });
        }

        function populateModelDropdown(models) {
            modelSelectOptions.innerHTML = '';
            models
                .slice()
                .sort((a, b) => sortLocale(a.name || '', b.name || ''))
                .forEach((model) => {
                    const div = document.createElement('div');
                    div.textContent = (model.name || '').trim();
                    const url = (model.url || '').trim();
                    div.dataset.url = url;
                    if (Array.isArray(model.generations)) {
                        div.dataset.hasGenerations = '1';
                    }
                    div.addEventListener('click', function () {
                        const url = (model.url || '').trim();
                        selectedModelGenerations = Array.isArray(model.generations) ? model.generations : null;

                        if (autoNavEnabled) {
                            saveSelectionsToLocalStorage({
                                brand: (brandCustomSelect.querySelector('.select-selected').value || '').trim(),
                                model: (model.name || '').trim(),
                                modelUrl: url,
                                years: ''
                            });
                            // 2026-09-21: см. выбор марки — поле показывает модель сразу, не дожидаясь подмены.
                            selectOption(this, modelCustomSelect, modelSelectOptions, false);
                            resetYearsSelect();
                            maybeNavigate(url);
                            return;
                        }

                        selectOption(this, modelCustomSelect, modelSelectOptions, true);
                        enableFilters();
                        fetchAndPopulateFilters(url);
                    });
                    modelSelectOptions.appendChild(div);
                });
        }

        async function fetchAndPopulateFilters(collectionUrl, preferredYears) {
            const fetchPage = async (page) => {
                const url = `${collectionUrl}?page=${page}&view=json`;
                const response = await fetch(url);
                if (!response.ok) throw new Error('Network response was not ok');
                return response.json();
            };

            try {
                const firstPageData = await fetchPage(1);
                let allProducts = firstPageData.products || [];
                const perPage = firstPageData.products && firstPageData.products.length;
                const totalPages = perPage
                    ? Math.ceil(firstPageData.total_products / perPage)
                    : 1;

                for (let page = 2; page <= totalPages; page++) {
                    const data = await fetchPage(page);
                    allProducts = allProducts.concat(data.products || []);
                }

                const years = new Set();
                allProducts.forEach((product) => {
                    if (product.years != null && String(product.years).trim() !== '') {
                        years.add(String(product.years).trim());
                    }
                });

                populateYearsDropdown([...years]);

                let yearsToSelect = String(preferredYears || '').trim();
                if (!yearsToSelect) {
                    const saved = localStorage.getItem('carFilterSelections');
                    if (saved) {
                        yearsToSelect = (JSON.parse(saved).years || '').trim();
                    }
                }

                if (yearsToSelect) {
                    const yearDiv = Array.from(yearsSelectOptions.children).find(
                        (div) => (div.dataset.years || div.textContent).trim() === yearsToSelect
                    );
                    if (yearDiv) {
                        selectYearOption(yearDiv, false);
                    } else {
                        console.warn(`Year "${yearsToSelect}" not found in available years:`, [...years]);
                    }
                }
            } catch (error) {
                console.error('Error fetching collection products:', error);
            }
        }

        function buildYearOptionElement(years) {
            const generation = findGeneration(years, selectedModelGenerations);
            const div = document.createElement('div');
            const label = formatGenerationLabel(generation, years);

            div.dataset.years = years;
            if (generation && generation.code) {
                div.dataset.code = String(generation.code).trim();
            }
            if (generation && generation.image) {
                div.dataset.image = String(generation.image).trim();
            }

            if (allowsFilterThumbs(container) && generation && generation.image) {
                div.className = 'filter-option filter-option--generation';
                div.innerHTML = `
          <span class="filter-option__text">${label}</span>
          <img class="filter-option__thumb" src="${fileUrl(container, generation.image)}" alt="" width="66" height="48" loading="lazy">
        `;
            } else {
                div.textContent = label;
            }

            div.addEventListener('click', function () {
                selectYearOption(this, true);
            });

            return div;
        }

        function populateYearsDropdown(years) {
            yearsSelectOptions.innerHTML = '';
            years
                .slice()
                .sort((a, b) => {
                    const rangeA = parseYearRangeForVehicleFilter(a);
                    const rangeB = parseYearRangeForVehicleFilter(b);
                    const startA = rangeA ? rangeA.start : Number.NEGATIVE_INFINITY;
                    const startB = rangeB ? rangeB.start : Number.NEGATIVE_INFINITY;
                    if (startB !== startA) return startB - startA;
                    const endA = rangeA ? rangeA.end : Number.NEGATIVE_INFINITY;
                    const endB = rangeB ? rangeB.end : Number.NEGATIVE_INFINITY;
                    if (endB !== endA) return endB - endA;
                    return sortLocale(String(b), String(a));
                })
                .forEach((year) => {
                    yearsSelectOptions.appendChild(buildYearOptionElement(String(year).trim()));
                });
        }

        function selectYearOption(element, saveToLocalStorage) {
            const yearsValue = (element.dataset.years || element.textContent || '').trim();
            const generation = findGeneration(yearsValue, selectedModelGenerations);
            const displayValue = formatGenerationLabel(generation, yearsValue);

            setFieldValue(yearsCustomSelect, displayValue, yearsValue);
            yearsCustomSelect.dataset.url = '';
            yearsSelectOptions.classList.add('select-hide');
            yearsCustomSelect.classList.add('selected');

            if (generation && generation.image) {
                setThumb(yearsCustomSelect, generation.image, 'generation');
            } else {
                setThumb(yearsCustomSelect, '', 'generation');
            }

            checkIfSearchEnabled();
            closeAllSelects();

            if (saveToLocalStorage) {
                saveSelectionsToLocalStorage();
            }

            if (autoNavEnabled && !suppressAutoNav) {
                const modelUrl = (modelCustomSelect.querySelector('.select-selected').dataset.url || '').trim();
                maybeNavigate(buildFilterUrl(modelUrl, yearsValue));
            }
        }

        function selectOption(element, selectWrapper, selectOptions, saveToLocalStorage) {
            const selected = selectWrapper.querySelector('.select-selected');
            const label = (element.textContent || '').trim();
            selected.value = label;
            selected.dataset.url = (element.dataset.url || '').trim();
            delete selected.dataset.years;
            selectOptions.classList.add('select-hide');
            selectWrapper.classList.add('selected');
            checkIfSearchEnabled();
            closeAllSelects();

            if (saveToLocalStorage) {
                saveSelectionsToLocalStorage();
            }
        }

        function buildUrl() {
            const brandElement = brandCustomSelect.querySelector('.select-selected');
            const modelElement = modelCustomSelect.querySelector('.select-selected');
            const brandUrl = (brandElement.dataset.url || '').trim();
            const modelUrl = (modelElement.dataset.url || '').trim();
            const baseUrl = modelUrl || brandUrl;
            const urlParams = new URLSearchParams();
            const yearsInput = yearsCustomSelect.querySelector('.select-selected');
            const years = (yearsInput.dataset.years || yearsInput.value || '').trim();

            if (years) {
                urlParams.set('filter.p.m.custom.filter_years', years);
            }

            const queryString = urlParams.toString();
            return baseUrl + (queryString ? '?' + queryString : '');
        }

        function resetModelSelect() {
            const modelInput = modelCustomSelect.querySelector('.select-selected');
            modelInput.value = '';
            delete modelInput.dataset.url;
            modelSelectOptions.innerHTML = '';
            modelCustomSelect.classList.remove('selected');
        }

        function enableModelSelect() {
            const modelInput = modelCustomSelect.querySelector('.select-selected');
            modelInput.classList.remove('disabled');
            modelInput.removeAttribute('disabled');
        }

        function enableFilters() {
            const yearsInput = yearsCustomSelect.querySelector('.select-selected');
            yearsInput.classList.remove('disabled');
            yearsInput.removeAttribute('disabled');
        }

        function closeAllSelects() {
            container.querySelectorAll('.select-items').forEach((item) => item.classList.add('select-hide'));
            container.querySelectorAll('.custom-select').forEach((select) => select.classList.remove('active'));
        }

        function toggleSelectOptions(selectOptions, customSelect) {
            const isOpen = !selectOptions.classList.contains('select-hide');
            closeAllSelects();
            if (!isOpen) {
                selectOptions.classList.remove('select-hide');
                customSelect.classList.add('active');
            }
        }

        function bindSelectToggle(customSelect, selectOptions) {
            const trigger = customSelect.querySelector('.filter-field__body') || customSelect;
            trigger.addEventListener('click', (event) => {
                if (event.target.closest('.select-items')) return;

                const input = customSelect.querySelector('.select-selected');
                if (!input || input.disabled || input.classList.contains('disabled')) return;

                startBrandsLoad();
                toggleSelectOptions(selectOptions, customSelect);
                if (document.activeElement !== input) {
                    input.focus({ preventScroll: true });
                }
            });
        }

        bindSelectToggle(brandCustomSelect, brandSelectOptions);
        bindSelectToggle(modelCustomSelect, modelSelectOptions);
        bindSelectToggle(yearsCustomSelect, yearsSelectOptions);

        /* --- Крестик очистки поля: стереть значение и сразу вернуться на шаг назад --- */
        function fieldInput(customSelect) {
          return customSelect.querySelector('.select-selected');
        }

        function updateClearButtons() {
          [brandCustomSelect, modelCustomSelect, yearsCustomSelect].forEach((customSelect) => {
            const btn = customSelect.querySelector('[data-filter-clear]');
            if (!btn) return;
            const input = fieldInput(customSelect);
            btn.hidden = !(input && (input.value || '').trim());
          });
        }

        function bindFieldClear(customSelect, kind) {
          const btn = customSelect.querySelector('[data-filter-clear]');
          if (!btn) return;

          btn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            try { localStorage.removeItem('carFilterSelections'); } catch (e) { /* приватный режим */ }

            if (kind === 'years') {
              const modelUrl = ((fieldInput(modelCustomSelect) || {}).dataset || {}).url || '';
              resetYearsSelect();
              closeAllSelects();
              checkIfSearchEnabled();
              updateClearButtons();
              if (autoNavEnabled) navigateIfNeeded(modelUrl);
              return;
            }

            if (kind === 'model') {
              const brandUrl = ((fieldInput(brandCustomSelect) || {}).dataset || {}).url || '';
              resetModelSelect();
              resetYearsSelect();
              setThumb(modelCustomSelect, '', 'generation');
              closeAllSelects();
              checkIfSearchEnabled();
              updateClearButtons();
              if (autoNavEnabled) navigateIfNeeded(brandUrl);
              return;
            }

            clearFilters.click();
            updateClearButtons();
          });
        }

        bindFieldClear(brandCustomSelect, 'brand');
        bindFieldClear(modelCustomSelect, 'model');
        bindFieldClear(yearsCustomSelect, 'years');

        container.addEventListener('click', () => setTimeout(updateClearButtons, 60));
        container.addEventListener('input', () => setTimeout(updateClearButtons, 60));
        setTimeout(updateClearButtons, 300);
        setTimeout(updateClearButtons, 1200);

        document.addEventListener('click', (event) => {
            const wrapper = event.target.closest('.custom-select-wrapper');
            if (!wrapper || !container.contains(wrapper)) {
                closeAllSelects();
            }
        });

        clearFilters.addEventListener('click', () => {
            const brandInput = brandCustomSelect.querySelector('.select-selected');
            brandInput.value = '';
            delete brandInput.dataset.url;
            modelCustomSelect.querySelector('.select-selected').value = '';
            resetYearsSelect();
            selectedBrandLogo = '';
            setThumb(brandCustomSelect, '', 'brand');
            setThumb(modelCustomSelect, '', 'generation');
            brandCustomSelect.classList.remove('selected');
            modelCustomSelect.classList.remove('selected');
            localStorage.removeItem('carFilterSelections');
            closeAllSelects();
            checkIfSearchEnabled();
        });

        searchButton.addEventListener('click', () => {
            navigateIfNeeded(buildUrl());
        });

        function checkIfSearchEnabled() {
            const selectedBrand = (brandCustomSelect.querySelector('.select-selected').value || '').trim();
            const brandUrl = (brandCustomSelect.querySelector('.select-selected').dataset.url || '').trim();
            searchButton.disabled = !(selectedBrand && brandUrl);
        }

        container.querySelector('.brand-input').addEventListener('input', () => filterSelectOptions('.brand-input', '.brand-select-options'));
        container.querySelector('.model-input').addEventListener('input', () => filterSelectOptions('.model-input', '.model-select-options'));
        container.querySelector('.years-input').addEventListener('input', () => filterSelectOptions('.years-input', '.years-select-options'));

        function renderOptionsEmptyState(optionsRoot, shouldShow) {
            if (!optionsRoot) return;
            let state = optionsRoot.querySelector('.brand-select-status');
            if (!shouldShow) {
                if (state) state.remove();
                return;
            }
            if (!state) {
                state = document.createElement('div');
                state.className = 'brand-select-status';
                state.setAttribute('role', 'status');
                optionsRoot.appendChild(state);
            }
            state.textContent = searchCopy.empty;
            state.style.display = '';
        }

        function filterSelectOptions(inputClass, optionsClass) {
            const input = container.querySelector(inputClass);
            const optionsRoot = container.querySelector(optionsClass);
            const divs = Array.from(optionsRoot.children).filter((div) => !div.classList.contains('brand-select-status') && !div.classList.contains('brand-select-loading'));

            if (inputClass === '.years-input') {
                const val = input.value.trim();
                if (!val) {
                    for (const div of divs) div.style.display = '';
                    renderOptionsEmptyState(optionsRoot, false);
                    return;
                }
                const year = parseInt(val, 10);
                if (isNaN(year)) {
                    for (const div of divs) div.style.display = 'none';
                    renderOptionsEmptyState(optionsRoot, true);
                    return;
                }
                let found = false;
                for (const div of divs) {
                    const txt = (div.dataset.years || div.textContent || '').trim();
                    const range = parseYearRangeForVehicleFilter(txt);
                    const visible = Boolean(range && year >= range.start && year <= range.end);
                    div.style.display = visible ? '' : 'none';
                    found = found || visible;
                }
                renderOptionsEmptyState(optionsRoot, !found);
                return;
            }

            const regexSpecials = new Set([92, 94, 36, 46, 42, 43, 63, 40, 41, 91, 93, 123, 125, 124]);
            const escaped = Array.from(input.value.toLowerCase(), (char) => regexSpecials.has(char.charCodeAt(0)) ? String.fromCharCode(92) + char : char).join('').replace(/s/g, '[sš]');
            const regex = new RegExp(escaped, 'i');
            let found = false;
            for (const div of divs) {
                const txtValue = ((div.textContent || div.innerText) || '').trim();
                const visible = regex.test(txtValue);
                div.style.display = visible ? '' : 'none';
                found = found || visible;
            }
            renderOptionsEmptyState(optionsRoot, Boolean(input.value.trim()) && !found);
            if (inputClass === '.brand-input' && input.value.trim() === '') {
                container.querySelector('.model-input').setAttribute('disabled', 'disabled');
            }
        }

        function saveSelectionsToLocalStorage(override) {
            const yearsInput = yearsCustomSelect.querySelector('.select-selected');
            const selections = override || {
                brand: (brandCustomSelect.querySelector('.select-selected').value || '').trim(),
                model: (modelCustomSelect.querySelector('.select-selected').value || '').trim(),
                modelUrl: (modelCustomSelect.querySelector('.select-selected').dataset.url || '').trim(),
                years: (yearsInput.dataset.years || yearsInput.value || '').trim()
            };
            localStorage.setItem('carFilterSelections', JSON.stringify(selections));
        }

        async function restoreBrandSelection(brandKey, brandData, saveToStorage) {
            const brandDiv = Array.from(brandSelectOptions.children).find(
                (div) => (div.dataset.brand || div.textContent || '').trim() === String(brandKey).trim()
            );
            if (!brandDiv) return false;

            selectedBrandLogo = (brandDiv.dataset.logo || '').trim();
            if (!selectedBrandLogo && brandData && brandData.logo) {
                selectedBrandLogo = String(brandData.logo).trim();
            }

            selectOption(brandDiv, brandCustomSelect, brandSelectOptions, saveToStorage);
            brandCustomSelect.querySelector('.select-selected').dataset.url = resolveBrandCollectionUrl(
                brandKey,
                brandData
            );
            setThumb(brandCustomSelect, selectedBrandLogo, 'brand');
            resetModelSelect();
            resetYearsSelect();

            if (brandData && Array.isArray(brandData.models)) {
                populateModelDropdown(brandData.models);
                enableModelSelect();
            }

            checkIfSearchEnabled();
            return true;
        }

        async function restoreModelSelection(brandKey, brandData, model, modelUrl, saveToStorage) {
            const modelName = (model.name || '').trim();
            const modelDiv = Array.from(modelSelectOptions.children).find(
                (div) => (div.textContent || '').trim() === modelName
            );
            if (!modelDiv) return false;

            modelDiv.dataset.url = String(modelUrl || model.url || '').trim();
            const modelData = brandData && Array.isArray(brandData.models)
                ? brandData.models.find((item) => (item.name || '').trim() === modelName)
                : null;
            selectedModelGenerations =
                modelData && Array.isArray(modelData.generations) ? modelData.generations : null;

            selectOption(modelDiv, modelCustomSelect, modelSelectOptions, saveToStorage);
            enableFilters();
            await fetchAndPopulateFilters(modelDiv.dataset.url, getYearsFilterFromUrl());
            return true;
        }

        async function restoreSelectionsFromPageContext() {
            const handle = (container.dataset.collectionHandle || '').trim();
            if (!handle || !localJson) return false;

            const match = findCatalogMatch(
                localJson,
                handle,
                container.dataset.pageBrand,
                container.dataset.pageModel
            );
            if (!match) return false;

            suppressAutoNav = true;

            const restoredBrand = await restoreBrandSelection(match.brandKey, match.brandData, false);
            if (!restoredBrand) {
                suppressAutoNav = false;
                return false;
            }

            if (match.level === 'model' && match.model) {
                await restoreModelSelection(
                    match.brandKey,
                    match.brandData,
                    match.model,
                    match.modelUrl,
                    false
                );
            }

            saveSelectionsToLocalStorage();
            suppressAutoNav = false;
            return true;
        }

        async function restoreSelectionsFromLocalStorage() {
            const saved = localStorage.getItem('carFilterSelections');
            if (!saved) {
                return;
            }

            const { brand, model, modelUrl } = JSON.parse(saved);
            let restoredBrandKey = null;

            if (brand) {
                const brandDiv = Array.from(brandSelectOptions.children).find(
                    (div) => {
                        const saved = (brand || '').trim();
                        const key = (div.dataset.brand || '').trim();
                        return div.textContent.trim() === saved || key === saved || (evmI18n.brandGroups && evmI18n.brandGroups[key] === saved);
                    }
                );
                if (brandDiv) {
                    restoredBrandKey = brandDiv.dataset.brand;
                    selectedBrandLogo = (brandDiv.dataset.logo || '').trim();
                    if (!selectedBrandLogo && restoredBrandKey && localJson[restoredBrandKey] && localJson[restoredBrandKey].logo) {
                        selectedBrandLogo = String(localJson[restoredBrandKey].logo).trim();
                    }
                    selectOption(brandDiv, brandCustomSelect, brandSelectOptions, false);
                    if (restoredBrandKey && localJson[restoredBrandKey]) {
                        brandCustomSelect.querySelector('.select-selected').dataset.url = resolveBrandCollectionUrl(
                            restoredBrandKey,
                            localJson[restoredBrandKey]
                        );
                    }
                    setThumb(brandCustomSelect, selectedBrandLogo, 'brand');
                    resetModelSelect();
                    if (restoredBrandKey && localJson[restoredBrandKey] && Array.isArray(localJson[restoredBrandKey].models)) {
                        populateModelDropdown(localJson[restoredBrandKey].models);
                        enableModelSelect();
                    }
                }
            }

            if (model && modelUrl) {
                const modelDiv = Array.from(modelSelectOptions.children).find(
                    (div) => div.textContent.trim() === (model || '').trim()
                );
                if (modelDiv) {
                    modelDiv.dataset.url = (modelUrl || '').trim();
                    const brandKey =
                        restoredBrandKey ||
                        (brand && localJson
                            ? Object.keys(localJson).find((key) => key.trim() === String(brand).trim())
                            : null);
                    const brandData = brandKey && localJson ? localJson[brandKey] : null;
                    if (brandData && Array.isArray(brandData.models)) {
                        const modelData = brandData.models.find(
                            (item) => (item.name || '').trim() === (model || '').trim()
                        );
                        selectedModelGenerations =
                            modelData && Array.isArray(modelData.generations) ? modelData.generations : null;
                    }
                    selectOption(modelDiv, modelCustomSelect, modelSelectOptions, false);
                    enableFilters();
                    await fetchAndPopulateFilters(modelUrl);
                }
            }

            checkIfSearchEnabled();
        }
    });

    // Переходы «назад/вперёд» после мягкой подмены: если запись наша — собираем страницу так же мягко,
    // если чужая (пришли обычной навигацией) — честно перезагружаем.
    if (swapMain() && swapAside() && window.history && typeof window.history.replaceState === 'function') {
        try {
            window.history.replaceState(Object.assign({}, window.history.state, { evmSwap: true }), '');
        } catch (_) { /* приватный режим */ }
        window.addEventListener('popstate', (event) => {
            if (!swapMain() || !swapAside()) return;
            if (!event.state || !event.state.evmSwap) { window.location.reload(); return; }
            softSwap(window.location.href, { push: false }).catch(() => window.location.reload());
        });
    }

    scheduleBrandsLoad(() => {
        filterContainers.forEach((container) => {
            if (typeof container.__evamatsStartBrandsLoad === 'function') {
                container.__evamatsStartBrandsLoad();
            }
        });
    });
})();

/* EVAMATS_SEARCH_CACHEBUST_20260831 */
